<div class="tooltip top" #tooltipBody [customProperty]="positionStyles$ | async">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 11" class="tooltip-arrow" width="22" height="11">
        <polyline
            fill="#333"
            stroke="#000"
            stroke-width="1"
            points="0,11 1,11 11,1 21,11 22,11"
            vector-effect="non-scaling-stroke"
        ></polyline>
    </svg>
    <div>
        <input-errors [control]="control" [immediate]="true"></input-errors>
    </div>
</div>
